/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Master9Inputs */

const en__field_enum_mzs_master9 = /** @type {(inputs: _Field_Enum_Mzs_Master9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de__field_enum_mzs_master9 = /** @type {(inputs: _Field_Enum_Mzs_Master9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {_Field_Enum_Mzs_Master9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_master9 = /** @type {((inputs?: _Field_Enum_Mzs_Master9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Master9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_master9(inputs)
	return de__field_enum_mzs_master9(inputs)
});
export { _field_enum_mzs_master9 as "_field_enum_MZS_MASTER" }